module.exports = __webpack_public_path__ + "static/img/IMG_20160820_201513.9d31cf0c.jpg";